import { render, staticRenderFns } from "./AdviserTermsSection.vue?vue&type=template&id=56993fb4&scoped=true"
import script from "./AdviserTermsSection.vue?vue&type=script&lang=js"
export * from "./AdviserTermsSection.vue?vue&type=script&lang=js"
import style0 from "./AdviserTermsSection.vue?vue&type=style&index=0&id=56993fb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56993fb4",
  null
  
)

export default component.exports